import { useEffect, useRef } from 'react';

export function useInterval(
  intervalAction: () => void,
  intervalDelay: number | null, // Delay in milliseconds or null to stop it
  intervalLimit?: number, // Limit in milliseconds
  intervalLimitAction?: () => void,
): void {
  const savedAction = useRef(intervalAction);
  const startInterval = intervalDelay !== null;

  // Remember the latest action
  useEffect(() => {
    savedAction.current = intervalAction;
  }, [intervalAction]);

  // Set up interval limit
  useEffect(() => {
    const startIntervalLimit =
      startInterval && intervalLimit && intervalLimitAction !== undefined;

    if (startIntervalLimit) {
      setTimeout(() => intervalLimitAction(), intervalLimit);
    }
  }, [intervalDelay, intervalLimit]);

  // Set up the interval
  useEffect(() => {
    const tick = (): void => {
      savedAction.current();
    };

    if (!startInterval) {
      return undefined;
    }

    const id = setInterval(tick, intervalDelay);
    return (): void => clearInterval(id);
  }, [intervalDelay]);
}
